<template>
  <svg
    width="12"
    height="16"
    viewBox="0 0 12 16"
  >
    <path d="M6 0.499818C5.58217 0.185973 5.0628 0 4.5 0C3.11929 0 2 1.11929 2 2.5V4H1C0.447715 4 0 4.44772 0 5V13C0 14.6569 1.34315 16 3 16H9.5C10.8807 16 12 14.8807 12 13.5V5C12 4.44772 11.5523 4 11 4H10V2.5C10 1.11929 8.88071 0 7.5 0C6.9372 0 6.41783 0.185973 6 0.499818ZM3 2.5C3 1.67157 3.67157 1 4.5 1C5.32843 1 6 1.67157 6 2.5V4H3V2.5ZM6.66694 1.25241C6.90523 1.09297 7.19176 1 7.5 1C8.32843 1 9 1.67157 9 2.5V4H7V2.5C7 2.04564 6.87879 1.61958 6.66694 1.25241ZM3 15C1.89543 15 1 14.1046 1 13V5H7V13.5C7 14.0628 7.18597 14.5822 7.49982 15H3ZM11 13.5C11 14.3284 10.3284 15 9.5 15C8.67157 15 8 14.3284 8 13.5V5H11V13.5Z" />
  </svg>
</template>
